import React, {Component} from 'react';
import {NavBar, Session, ItemsList, ItemDetailsModal, Footer, Slider, CarouselDashboard, Suscription, TopNavBar} from "../../components";
import {config, DISPATCH_ID, VIEW_NAME, SERVICE_API, ROLES} from "../../libs/utils/Const";
import { ApiClient } from "../../libs/apiClient/ApiClient";
import {connect} from "react-redux";
import Carousel from 'react-multi-carousel';
import './ItemsView.css';

const apiClient = ApiClient.getInstance();

const responsiveCategories = {
    desktop: {
        breakpoint: { max: 3500, min: 1920 },
        items: 6,
        partialVisibilityGutter: 10 // this is needed to tell the amount of px that should be visible.
      },
      tablet: {
        breakpoint: { max: 1920, min: 1200 },
        items: 4,
        partialVisibilityGutter: 30 // this is needed to tell the amount of px that should be visible.
      },
      tablet2: {
        breakpoint: { max: 1200, min: 768 },
        items: 3,
        partialVisibilityGutter: 30 // this is needed to tell the amount of px that should be visible.
      },
      tablet3: {
        breakpoint: { max: 768, min: 465 },
        items: 1,
        partialVisibilityGutter: 30 // this is needed to tell the amount of px that should be visible.
      },
      mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        partialVisibilityGutter: 10 // this is needed to tell the amount of px that should be visible.
      } 
}

class ItemsFerreteria extends Component {

    changeQuantity = (index, item, newQuantity, addItem) => {
        const {itemsReducer : { addShoppingCart, deleteShoppingCart }} = this.props;
        if(addItem){
            // addShoppingCart({item, quantity: (newQuantity || '1')})
            addShoppingCart({
                item, quantity: (newQuantity && (!item.SalPackUn || Number(item.SalPackUn) === 1 || (item.SalUnitMsr === 'KG' && newQuantity > 1)) ? newQuantity
                    : item.SalPackUn && item.SalPackUn > 1 && item.SalUnitMsr === 'KG' ? item.SalPackUn :
                        item.SalPackUn && item.SalPackUn > 1 && (!Number(newQuantity) || (Number(newQuantity) === 1)) ? item.SalPackUn : newQuantity || '1')
            });
        }else{
            deleteShoppingCart({item, deleteAll: false});
        }
    };

    changeBackOrder= (item, addItem) => {
        const {itemsReducer : {deleteBackOrder, addBackOrder}} = this.props;
        if(addItem){
            addBackOrder({item, quantity: 1})
        }else{
            deleteBackOrder({item, deleteAll: false});
        }
    };

    render() {
        const {history,itemsReducer : { itemsFilter, searchItemsFilter, updateFavorite, deleteShoppingCart, openItemDetails }} = this.props;
        return (
            <div className="container-fluid" style={{marginTop: 100,backgroundColor:"#FFFFFF", paddingLeft:0, paddingRight:0}}>
                <Session history={history} view={VIEW_NAME.ITEMS_FERRETERIA_VIEW}/>
                <NavBar/>
                <div className="bannerRedCompensas margenS" style={{backgroundColor:"#FFFFFF"}}>
                    <img id = "scrollDownPlease" className="img-fluid"
                        src={require('../../images/irco/bannerPaginas/BANNER-FERRETERIA-.png')}
                        alt="Segundo NavBar"
                    />
                </div>
                <TopNavBar/>
                {/**Comineza funcion */}
                {/* NOTA: No se puede ejecutar el componente porque no se escribe ninguna palabra */}
                <div className="row" style={{margin:0, paddingBottom: 20}}>
                    <div className="col-md-12 col-sm-12" style={{margin:0, minHeight: '70vh'}}>
                        {!!itemsFilter && itemsFilter.length !== 0 ? (
                            <ItemsList
                                items={itemsFilter}
                                updateFavorite={updateFavorite}
                                openDetails={openItemDetails}
                                changeQuantity={this.changeQuantity}
                                deleteShoppingCart={deleteShoppingCart}
                                changeBackOrder={this.changeBackOrder}
                                viewOne={'Ferreteria'}
                            />
                        ) : (
                            <div style={{paddingTop:100, margin:0, textAlign: 'center'}}>No se encontraron productos
                                <br/>
                                <br/>
                                <i style={{fontSize: 70}} className={config.icons.search}></i>
                            </div>
                        )}

                    </div>
                </div>
                {/* <Suscription/> */}
                {/**Aqui termina la funcion  */}
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        itemsReducer: store.ItemsReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
        sessionReducer: store.SessionReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setItemsSearch: value => dispatch({type: DISPATCH_ID.ITEMS_SET_ITEMS, value}),
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
        setItemsFilterSearch: value => dispatch({type: DISPATCH_ID.ITEMS_SAVE_ITEMS_FILTER, value}),
        setLocation:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_LOCATION, value}),
        setTotalRows : value => dispatch({type: DISPATCH_ID.ITEMS_SET_TOTALROWS, value}),
        setLocation:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_LOCATION, value}),
        setIdCategory: value => dispatch({type: DISPATCH_ID.ITEMS_SET_IDCATEGORY, value}),
        setNextPage:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_NEXTPAGE, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ItemsFerreteria);